export enum TrackingEvent {
  ClickedLink = `Clicked Breadcrumb Link`,
}
